import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_plan_maintenance_maintenance_item_code'),
        dataIndex: 'code',
        key: 'code',
        width:150,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            <span>
              { sort }
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_items'),
        dataIndex: 'name',
        key: 'name',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('page_plan_maintenance_maintenance_judgment'),
        dataIndex: 'isExecute',
        key: 'isExecute',
        width:150,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            <span>
              { sort == 1 ? this.$t('yes') : this.$t('no')}
            </span>
          )
        },
      },
      {
        title: this.$t('page_plan_maintenance_requirements'),
        dataIndex: 'requirement',
        key: 'requirement',
        width:150,
        ellipsis: true
      },
      {
        title: this.$t('remark'),
        dataIndex: 'remark',
        key: 'remark',
        width:150,
        ellipsis: true
      }
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;

  render() {
    return (
      <div>
        <ml-table
            pagination={false}
            columns={this.columns}
            dataSource={this.data}
            bordered
            row-key="id"
            loading={this.loading}
            scroll={{ y: this.height}}
        >
        </ml-table>
      </div>
    )
  }
}